import { config } from '../../../config/config';

export function getDefaultJurisdictionFromRegion(countryCode?: string) {
    if (countryCode && countryCode in config.DEFAULT_JURISDICTION_COUNTRIES) {
        return (
            config.DEFAULT_JURISDICTION_COUNTRIES[
                countryCode as keyof typeof config.DEFAULT_JURISDICTION_COUNTRIES
            ] ?? config.DEFAULT_JURISDICTION
        );
    }

    return config.DEFAULT_JURISDICTION;
}
